import React, { useEffect, useState } from 'react';
import { Avatar } from '@mui/material';

function getInitials(name) {
  if (!name || typeof name !== 'string') return 'U';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return (parts[0]?.[0] || 'U').toUpperCase();
}

/** SSO /users/me picture or avatar_url (https or data URL only). */
export function resolveProfilePictureUrl(user) {
  const raw = String(user?.picture || user?.avatar_url || '').trim();
  if (raw.startsWith('https://') || raw.startsWith('data:image/')) return raw;
  return '';
}

/**
 * Avatar that prefers SSO profile photo, falls back to initials.
 * Uses referrerPolicy=no-referrer so Google/GitHub CDN images load.
 */
const UserAvatar = ({ user, name, sx, ...rest }) => {
  const picture = resolveProfilePictureUrl(user);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [picture]);

  const src = picture && !failed ? picture : undefined;
  const displayName = name || user?.name;

  return (
    <Avatar
      src={src}
      alt={displayName || 'Account'}
      slotProps={{
        img: {
          referrerPolicy: 'no-referrer',
          onError: () => setFailed(true),
        },
      }}
      sx={sx}
      {...rest}
    >
      {getInitials(displayName)}
    </Avatar>
  );
};

export default UserAvatar;
